<template>
    <div class="bill_addon clr">
        <standart title="Затвердження договору" key="bill_addon" v-bind:is_active_result=false v-bind:is_active_problem=false></standart>
    </div>
</template>

<script>
import standart from '../standart.vue'

export default {
    name: "dogovor",
    components: {
        standart,
    },
    data() {
        return {
            form: {
                counterparty_items: []
            },
        }
    },
    
    mounted() {
        setTimeout(() => EventBus.$emit('remove_dir'), 500);
    },
    
 
    methods: {
    
    
    },
    
    computed: {
    
    },
    
}

</script>

<style scoped>

</style>
